import { Construction } from "lucide-react";

export default function Placeholder({ title }) {
  return (
    <div className="flex flex-col items-center justify-center min-h-[60vh] text-center" data-testid="placeholder-page">
      <Construction className="w-16 h-16 text-slate-300 mb-4" />
      <h2 className="text-2xl font-bold text-slate-900">{title}</h2>
      <p className="text-sm text-slate-500 mt-2">Esta sección está en construcción</p>
    </div>
  );
}
